export const CATEGORY_FIELD = 'search_str';
export const SUBURB_FIELD = 'w';
export const SCOPE_OF_WORK_FIELD = 'scope_of_work';
export const JOB_DESCRIPTION_FIELD = 'job_description';
export const START_BY_FIELD = 'start_by';
